module.exports = __webpack_public_path__ + "content.svg?00ae6c902a6f946ed7331c748008d539";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content.svg
// module id = 284
// module chunks = 2